export default function preloader() {
    let loaded = false;

    function preloader() {
        document.getElementById("rezgo-loading").style.display = "none";
        document.getElementById("rezgo_content_frame").style.display = "block";
        loaded = true;
        console.log(loaded);
    }

//preloader
    var loadiframe = document.getElementById("rezgo_content_frame");
    if (loadiframe) {
        loadiframe.onload = preloader;
    }
}
